export default {
    getSelectedRoomId: state => state.selectedRoomId,
    getOptionVersionIds: state => state.optionVersionIds,
    getSelectedVersionId: state => state.selectedVersionId,

    getChannelTimeFrom: state => state.channelTimeFrom,
    getChannelTimeTo: state => state.channelTimeTo,

    getLastChannelTimeFrom: state => state.lastChannelTimeFrom,
    getLastChannelTimeTo: state => state.lastChannelTimeTo,

    getRooms: state => state.rooms,
}